declare var x_textos: any;
// ponytail: submódulos en vez del índice completo de crypto-js — solo se usan AES, SHA1 y enc
import AES from 'crypto-js/aes';
import SHA1 from 'crypto-js/sha1';
import Utf8 from 'crypto-js/enc-utf8';
import Hex from 'crypto-js/enc-hex';
import LZString from 'lz-string';
import { iUtilsTM } from './tagManager';
import { Loader } from '@googlemaps/js-api-loader';

// motivo de error → [texto, botón]. texto = ID de adm_landing (ID-0 título, ID-1 cuerpo);
// botón = ID cuya ID-0 es la etiqueta. link_vencido, error_tecnico, error_actualizar y
// sucursal_no_disponible los pone el frontend; el resto viene del backend (selModelo / alquilarCarro).
const MOTIVOS_ERROR: { [motivo: string]: [number, number] } = {
    sin_disponibilidad: [3310, 3341], tarifa_cambio: [3311, 3342], tarifa_vencida: [3312, 3342],
    ya_reservado: [3313, 3343], proveedor_no_disponible: [3314, 3340], cupon_invalido: [3315, 3345],
    aerolinea_invalida: [3316, 3346], datos_cliente_invalidos: [3317, 3345], reserva_rechazada: [3318, 3340],
    forma_pago_cambio: [3319, 3342], edad_minima: [3320, 3345], codigo_vencido: [3321, 3344],
    error_inesperado: [3322, 3340], edad_maxima: [3323, 3345], edad_invalida: [3324, 3345],
    rentadora_no_habilitada: [3325, 3342], fechas_invalidas: [3326, 3347], contactar_soporte: [3327, 3348],
    link_vencido: [3328, 3344], error_tecnico: [3329, 3340], error_actualizar: [3330, 3340],
    sucursal_no_disponible: [3331, 3341],
};
// Botones que llevan a una búsqueda nueva / al contacto. Los demás ("Intentar nuevamente",
// "Revisar datos/aerolínea") hacen lo que diga el llamador (cerrar el modal o recargar).
const BOTONES_VOLVER = [3341, 3342, 3343, 3344, 3347];
const BOTON_CONTACTO = 3348;

export class Utils implements iUtilsTM {

    // null = <body> sin lock; ver el guard dentro de openBrandModal().
    private static bodyScrollLockY: number | null = null;

    // openBrandModal() bloquea el scroll de fondo (ver ahí) sacando <body> del flujo con
    // position:fixed — pero Bootstrap igual pone `body.style.overflow = 'hidden'` encima, lo
    // que resetea el scrollTop REAL de <body> a 0 (efecto nativo del navegador, no algo que
    // podamos evitar sin parchear Bootstrap) y dispara un evento 'scroll' genuino con
    // window.scrollY = 0 mientras el lock sigue activo. Cualquier listener de scroll ajeno en
    // la página (ej. el sticky-resumen de paso3.ts::onscroll()) que reaccione a ESE 0 como si
    // el usuario hubiera vuelto al top queda corrompido. Los listeners sitewide deben chequear
    // esto e ignorar el evento mientras el lock esté activo.
    static isScrollLocked(): boolean {
        return Utils.bodyScrollLockY !== null;
    }

    findText(pal: any) {
        let self = this;
        if (pal == null) return '';
        var txtreturn = ''
        if (typeof pal == 'object') {
            $.each(pal, function (index, data) {
                var pre_txtreturn = ''
                    , t_data = ''
                    , isObject = typeof data == 'object' && data !== null
                    , isFormat = false
                if (isObject) {
                    t_data = data.text
                    isFormat = data.format == true
                }
                else {
                    t_data = data
                }

                if (isObject && !isFormat) {
                    pre_txtreturn = JSON.stringify(t_data)
                }
                else if (typeof t_data == 'object') {
                    pre_txtreturn = pre_txtreturn + ' ' + self.findText(t_data)
                }
                else if (String(t_data).substr(0, 4) == 'txt-') {
                    pre_txtreturn = pre_txtreturn + ' ' + self.getWord(t_data)
                }
                else if (t_data == '||') {
                    pre_txtreturn = pre_txtreturn + '<br />';
                }
                else {
                    pre_txtreturn = pre_txtreturn + ' ' + t_data
                }

                if (isFormat) {
                    txtreturn += '<span style="' + data.css + '">' + pre_txtreturn + '</span>'
                }
                else {
                    txtreturn += pre_txtreturn
                }
            })
        }
        else {
            if (String(pal).substr(0, 4) == 'txt-') {
                txtreturn = this.getWord(pal)
            }
            else {
                txtreturn = pal
            }
        }

        if (typeof txtreturn == 'string') {
            txtreturn = txtreturn.trim()
        }
        return txtreturn
    };


    /**
     * Obtiene un texto de forma segura, verificando que x_textos esté disponible
     * @param key - Clave del texto a obtener
     * @param defaultValue - Valor por defecto si no se encuentra (opcional)
     * @returns El texto solicitado o el valor por defecto
     */
    getWord(key: any, defaultValue: string = '') {
        if (String(key).substr(0, 4) == 'txt-') {
            key = String(key).substr(4)
        }
        if (typeof x_textos === 'undefined' || x_textos === null) {
            console.warn(`Utils.getWord: x_textos no está disponible. Clave: ${key}`);
            return defaultValue;
        }
        if (typeof x_textos[key] === 'undefined') {
            console.warn(`Utils.getWord: Texto no encontrado para la clave: ${key}`);
            return defaultValue;
        }
        return (x_textos[key]);
    };

    /**
     * Título, cuerpo y botón (adm_landing) del `motivo` de error. null si no hay motivo o el texto
     * aún no está en x_textos (dinamic_info sin regenerar): el llamador cae a su mensaje de siempre.
     * accion: 'volver' = búsqueda nueva, 'contacto' = WhatsApp/teléfono, 'otro' = lo decide el llamador.
     */
    textoMotivo(motivo?: string | null, valor?: string | number | null): { titulo: string, cuerpo: string, boton: string, accion: 'volver' | 'contacto' | 'otro' } | null {
        const [id, boton] = (motivo && MOTIVOS_ERROR[motivo]) || [0, 0];
        if (!id || !this.isTextosAvailable() || !x_textos[`${id}-1`]) return null;
        // {0} = dato del motivo (ej. la edad mínima de la rentadora)
        const conValor = (t: string) => String(t).split('{0}').join(String(valor ?? '').replace(/[<>&"']/g, '')); // se pinta como HTML: sin caracteres de marcado
        return {
            titulo: conValor(x_textos[`${id}-0`] ?? ''), cuerpo: conValor(x_textos[`${id}-1`]), boton: x_textos[`${boton}-0`] ?? '',
            accion: BOTONES_VOLVER.includes(boton) ? 'volver' : boton === BOTON_CONTACTO ? 'contacto' : 'otro',
        };
    }

    /**
     * Qué hace el botón del modal de error. `otro` = "Intentar nuevamente"/"Revisar…" en ese contexto.
     * linkVolver: búsqueda a la que vuelve; por defecto la del paso 3 (#reserva data-link_busqueda).
     */
    clickMotivo(accion: string | undefined, otro: () => void, linkVolver?: string | null): () => void {
        if (accion === 'volver') return () => {
            let link = linkVolver || document.querySelector('#reserva')?.getAttribute('data-link_busqueda');
            if (!link) return history.back();
            if (!link.startsWith('/') && !link.startsWith('http')) link = '/' + link; // relativo acumula el path
            window.location.href = link;
        };
        if (accion === 'contacto') return () => {
            // primer enlace del bloque de soporte del layout: WhatsApp si hay, si no el teléfono
            const tpl = document.querySelector<HTMLTemplateElement>('#tpl-modal-support, #tpl-modal-support-mobile');
            const href = tpl?.content.querySelector('a')?.getAttribute('href');
            if (href) window.open(href, href.startsWith('http') ? '_blank' : '_self');
            otro();
        };
        return otro;
    }

    /**
     * Verifica si x_textos está disponible
     * @returns true si x_textos está disponible, false en caso contrario
     */

    isTextosAvailable(): boolean {
        return typeof x_textos !== 'undefined' && x_textos !== null;
    }

    construirDataForm($form: JQuery<HTMLElement>) {
        // Serializar todos los datos del formulario
        const serializedData = $form.serializeArray();
    
        // Obtener el valor de tipo_pago desde los datos serializados
        const tipoPagoField = serializedData.find(field => field.name === 'tipo_pago');
        const tipoPago = tipoPagoField ? tipoPagoField.value : '';
        let titularKey = '', inputs: string[] = [];
    
        switch (tipoPago) {
            case 'credito':
                titularKey = 'titular_credito';
                inputs = ['ctipodc', 'cdocuc', 'cnombrec', 'capellidoc', 'cemailc', 'cciudadc', 'ccelularc'];
                break;
            case 'debito':
                titularKey = 'titular_debito';
                inputs = ['ctipod', 'cdocud', 'cnombred', 'capellidod', 'cemaild', 'cciudadd', 'ccelulard'];
                break;
            default:
                return serializedData;
        }
    
        // Crear un mapeo de los inputs con sus selectores asociados
        const inputMapping: Record<string, string> = {
            [inputs[0]]: 'tdoc',
            [inputs[1]]: 'ndoc',
            [inputs[2]]: 'name',
            [inputs[3]]: 'lastname',
            [inputs[4]]: 'email',
            [inputs[5]]: 'ciudad',
            [inputs[6]]: 'tel2',
        };

        // Crear un mapeo de valores desde los datos serializados
        const serializedDataMap = Object.fromEntries(serializedData.map(({ name, value }) => [name, value]));

        // Agregar nuevos campos al formulario
        const additionalFields = inputs.map(inputName => {
            const relatedField = serializedData.find(field => field.name === inputMapping[inputName]);
            const value: any = relatedField ? relatedField.value : '';
            return { name: inputName, value };
        });

        // Combinar los datos serializados con los nuevos campos
        const combinedData = [...serializedData, ...additionalFields];
      

        return combinedData;
    }
    

    construirDataFormNew($form: JQuery<HTMLElement>) {
        // Serializar todos los datos del formulario
        const serializedData = $form.serializeArray();
    
        // Obtener el valor de tipo_pago desde los datos serializados
        const tipoPagoField = serializedData.find(field => field.name === 'payment');
       
        const tipoPago = tipoPagoField ? tipoPagoField.value : '';
        let titularKey = '', inputs: string[] = [];
    
        switch (tipoPago) {
            case 'paypal':
                titularKey = 'titular_debito_paypal';
                inputs = [
                    'ctipod',
                    'cdocud',
                    'cnombred',
                    'capellidod',
                    'cemaild',
                    'cciudadd',
                    'ccelulard'
                ];
                break;
            case 'credit':
                titularKey = 'titular_credit_card';
                inputs = [
                    'ctipodc',
                    'cdocuc',
                    'cnombrec',
                    'capellidoc',
                    'cemailc',
                    'cciudadc',
                    'ccelularc'
                ];
                break;
            case 'epayco':
                titularKey = 'titular_debito_epayco';
                inputs = [
                    'ctipod',
                    'cdocud',
                    'cnombred',
                    'capellidod',
                    'cemaild',
                    'cciudadd',
                    'ccelulard'
                ];
                break;
            case 'pse':
                titularKey = 'titular_debito_pse';
                inputs = [
                    'ctipod',
                    'cdocud',
                    'cnombred',
                    'capellidod',
                    'cemaild',
                    'cciudadd',
                    'ccelulard'
                ];
                break;

            case 'mercado_pago':
                titularKey = 'titular_credit_card_mercado_pago';
                inputs = [
                    'ctipodc',
                    'cdocuc',
                    'cnombrec',
                    'capellidoc',
                    'cemailc',
                    'cciudadc',
                    'ccelularc'
                ];
                break;
            default:
                return serializedData;
        }
    
        // Crear un mapeo de los inputs con sus selectores asociados
        const inputMapping: Record<string, string> = {
            [inputs[0]]: 'tdoc',
            [inputs[1]]: 'ndoc',
            [inputs[2]]: 'name',
            [inputs[3]]: 'lastname',
            [inputs[4]]: 'email',
            [inputs[5]]: 'ciudad',
            [inputs[6]]: 'tel2',
        };

        // Crear un mapeo de valores desde los datos serializados
        const serializedDataMap = Object.fromEntries(
            serializedData.map(
                ({ name, value }) => [name, value]
            )
        );

        // Agregar nuevos campos al formulario
        const additionalFields = inputs.map(inputName => {
            const relatedField = serializedData.find(field => field.name === inputMapping[inputName]);
            const value: any = relatedField ? relatedField.value : '';
            return { name: inputName, value };
        });
        
        // Combinar los datos serializados con los nuevos campos
        const combinedData = [...serializedData, ...additionalFields];
        
        return combinedData;
    }

    serializarData(dataForm: any, $frut: any = undefined, $fcc: any = undefined) {
        let formData = new FormData();
        for (let k in dataForm) {
            formData.append(dataForm[k].name, dataForm[k].value)
        }

        if ($frut && $frut.length != 0) {
            formData.append('frut', $frut.get(0).files[0]);
        }

        if ($fcc && $fcc.length != 0) {
            formData.append('fcc', $fcc.get(0).files[0]);
        }

        formData.append('csrf_token', this.getCsrfToken());  // Agrega el token CSRF a los datos

        return formData
    }

    getPriceAjax(formData: any, callback_success: any, callback_error: any) {

        $.ajax({
            url: '/action/get-price/',
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (data) {
                callback_success(data);
            },
            error: function (xhr, status) {
                callback_error(xhr, status);
            }
        });
    }

    private closeModalForceTimer?: ReturnType<typeof setTimeout>;

    /**
     * Compatibilidad con los ~30 call sites existentes de sendMsjModal en todo el sitio —
     * delega en openBrandModal() traduciendo su firma vieja al config nuevo. Así todo modal
     * que ya llama sendMsjModal() adopta la piel de marca sin tocar cada call site a mano.
     * `bg_title` (bg-warning/etc.) ya no aplica: el header del sistema nuevo es siempre el
     * azul de marca — ningún call site actual lo usaba distinto del default de todas formas.
     */
    sendMsjModal(msj: string, title: string, auto_close = true, text_btn?: string | false, callback_confirmacion?: () => void, time = 3000, cargando = false, btn_close = false, _bg_title = "bg-primary") {
        const spinnerHtml = cargando
            ? '<div class="text-center p-3"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div></div>'
            : '';

        // El eyebrow de openBrandModal ya dice "Mensaje de alkilautos.com" — un título
        // genérico igual o parecido (x_textos['550-0'], o el viejo fallback "Mensaje"/
        // "Message" de acá abajo) se veía como el mismo texto repetido dos veces. Se omite
        // el título en esos casos puntuales; un título real (ej. "Tarjeta rechazada") se
        // sigue mostrando normal.
        const genericTitles = [x_textos['550-0'], alk_lang === 'en' ? 'Message' : 'Mensaje', 'Alkilautos'];
        const finalTitle = title && !genericTitles.includes(title) ? title : undefined;

        this.openBrandModal({
            title: finalTitle,
            body: msj + spinnerHtml,
            cta: text_btn ? { text: text_btn, onClick: callback_confirmacion || (() => this.closeMsjModal()) } : undefined,
            closable: btn_close,
            autoCloseMs: auto_close ? time : undefined
        });
    }

    goTo(url: string) {
        if (alk_lang != 'es') {
            window.location.href = '/' + alk_lang + url;
        } else {
            window.location.href = url;
        }
    }

    closeMsjModal() {
        $("#modal").modal("hide");
        $("#modal-forgot").modal("hide");
        $('#modal-registrate').modal('hide');
        $('#modal-login').modal('hide');

        // Bootstrap ignora el hide() si el modal todavía está a mitad de la
        // animación de apertura (típico en local, donde el AJAX resuelve más
        // rápido que el fade-in). Forzamos el cierre visual sin esperar a
        // que termine esa transición. Si mientras tanto se abre un modal
        // nuevo (sendMsjModal), este timer se cancela para no cerrarlo.
        clearTimeout(this.closeModalForceTimer);
        this.closeModalForceTimer = setTimeout(() => {
            $('.modal.show').modal('hide');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open').css('overflow', '').css('padding-right', '');
        }, 350);
    }

    /**
     * Modal de marca (header sólido + ilustración circular sobrepuesta + CTA + soporte).
     * Reusa el mismo #modal/Bootstrap Modal de sendMsjModal — misma mecánica de foco/ESC/backdrop,
     * solo cambia la piel visual y la composición del contenido.
     */
    openBrandModal(config: {
        /** Ilustración circular sobre el header. Si se omite, el header no la reserva espacio para ella (modales de solo texto). */
        icon?: string,
        /** Si se omite, no hay encabezado grande — el mensaje va solo (evita repetir "Mensaje de alkilautos.com" dos veces en mensajes genéricos del backend). */
        title?: string,
        body: string,
        highlight?: string,
        cta?: { text: string, href?: string, onClick?: () => void },
        secondaryCta?: { text: string, href?: string, onClick?: () => void },
        support?: boolean,
        closable?: boolean,
        /** Color del círculo interior de la ilustración (ej. rojo en error, verde en éxito). Por defecto, el azul de marca. */
        accentColor?: string,
        /** Insignia roja de alerta ("!") sobre el borde de la ilustración — variantes de error/advertencia. */
        alertBadge?: boolean,
        /** Si se define, el modal se cierra solo después de estos ms (equivalente al auto_close/time de sendMsjModal). */
        autoCloseMs?: number,
        /** Anillo girando sobre el borde de la ilustración — variante de proceso/carga. */
        loading?: boolean
    }) {
        // Si había un cierre forzado pendiente de un modal anterior (ver closeMsjModal),
        // lo cancelamos: este modal nuevo no debe cerrarse por ese timer.
        clearTimeout(this.closeModalForceTimer);

        let modal = $('#modal');
        let modalDialog = $('#modal .modal-dialog');

        modal.addClass('modal-brand');
        modal.toggleClass('modal-brand-no-icon', !config.icon);

        // El sitio corre en Quirks Mode (sin <!DOCTYPE> válido) — eso hace que <body>, no <html>,
        // sea document.scrollingElement. Modal.show() de Bootstrap 5 pone `body.style.overflow =
        // 'hidden'` para bloquear el scroll de fondo (ScrollBarHelper.hide()); en cualquier
        // elemento, overflow:hidden resetea su scrollTop a 0 — y como acá ESE elemento es el
        // scroller real de la página, la página entera salta al top. Restaurar el scroll
        // DESPUÉS (solo con "shown.bs.modal") no basta: mientras overflow:hidden siga activo,
        // el navegador no deja fijar un scrollTop distinto de 0. Imita el truco de iOS: saca
        // <body> del flujo con position:fixed + top negativo ANTES de que Bootstrap toque
        // overflow — la posición se simula sin depender de scrollTop, inmune a que
        // overflow:hidden la resetee. Se revierte en "hidden.bs.modal".
        //
        // Aparte del salto visual, el focus-trap de Bootstrap (focustrap.js -> trapElement.
        // focus()) dispara un evento 'scroll' real en window aunque, gracias al lock de arriba,
        // no haya salto visible — y en ESE instante window.scrollY vale 0 (efecto lateral del
        // propio lock). Cualquier listener de scroll ajeno en la página (ej. el que fija/suelta
        // el resumen sticky en paso3.ts::onscroll()) recibe ese 0 espurio como si el usuario
        // hubiera vuelto al top, y si en ese momento recalcula su propia posición de referencia
        // usando ese 0, queda corrompido permanentemente (el resumen se queda "pegado" para
        // siempre, ver el bug reportado). Se neutraliza con preventScroll en ESE focus puntual
        // para que el evento 'scroll' espurio ni siquiera se dispare.
        const modalEl = modal.get(0) as HTMLElement;
        const originalFocus = modalEl.focus.bind(modalEl);
        modalEl.focus = ((options?: FocusOptions) => originalFocus({ ...options, preventScroll: true })) as HTMLElement['focus'];
        modal.one('shown.bs.modal', () => { modalEl.focus = originalFocus; });
        //
        // Guard con Utils.bodyScrollLockY: mostrarModalBusqueda()/ocultarModalBusqueda() (ver
        // generarFactura.ts) abren y cierran este modal repetidamente mientras el cliente
        // escribe el documento — si cada llamada capturara su propio scrollY sin chequear si ya
        // había un lock activo, una llamada anidada mientras <body> YA está position:fixed
        // leería window.scrollY = 0 (efecto lateral del propio truco) y lo guardaría como el
        // valor "real" a restaurar, perdiendo la posición original. Solo la primera llamada de
        // una secuencia superpuesta aplica el lock y guarda el valor a restaurar.
        if (Utils.bodyScrollLockY === null) {
            Utils.bodyScrollLockY = window.scrollY;
            // Ancho en px fijo, NO '100%': Bootstrap además le suma `padding-right` a <body>
            // para compensar el scrollbar que desaparece con overflow:hidden — con
            // box-sizing:content-box (default), '100%' + ese padding-right SUMAN, dejando a
            // <body> momentáneamente más ancho que antes del lock. Cualquier código que mida
            // anchos en ese instante (ej. #resumen fijándose su propio width inline en
            // paso3.ts::onscroll(), disparado por el window.scrollTo() del cierre) capturaba
            // ese ancho inflado y lo dejaba mal permanentemente. clientWidth ya excluye
            // cualquier padding/scrollbar propio de <body>, así que congelarlo en px es inmune
            // a esa suma.
            document.body.style.width = `${document.body.clientWidth}px`;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${Utils.bodyScrollLockY}px`;
        }
        modal.one('hidden.bs.modal', () => {
            if (Utils.bodyScrollLockY === null) return;
            const scrollY = Utils.bodyScrollLockY;
            Utils.bodyScrollLockY = null;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            // behavior:'instant' explícito — window.scrollTo(x, y) posicional respeta
            // `scroll-behavior: smooth` del sitio, así que sin esto la restauración se ve
            // primero saltar a 0 (instante en que se quita el position:fixed) y LUEGO animar
            // de vuelta hacia scrollY, un efecto feo que no existía antes del scroll-lock.
            window.scrollTo({ left: window.scrollX, top: scrollY, behavior: 'instant' });
        });

        modal.modal({ backdrop: 'static' }).modal('show');

        const closeBtn = config.closable !== false
            ? '<button type="button" class="modal-brand-close" data-bs-dismiss="modal" aria-label="Cerrar">&times;</button>'
            : '';

        const highlightHtml = config.highlight
            ? `<div class="modal-brand-highlight">${config.highlight}</div>`
            : '';

        const ctaHtml = config.cta
            ? (config.cta.href
                ? `<a href="${config.cta.href}" class="modal-brand-cta" id="modal-brand-cta">${config.cta.text}</a>`
                : `<button type="button" class="modal-brand-cta" id="modal-brand-cta">${config.cta.text}</button>`)
            : '';

        const secondaryCtaHtml = config.secondaryCta
            ? (config.secondaryCta.href
                ? `<a href="${config.secondaryCta.href}" class="modal-brand-cta modal-brand-cta--secondary" id="modal-brand-cta-secondary">${config.secondaryCta.text}</a>`
                : `<button type="button" class="modal-brand-cta modal-brand-cta--secondary" id="modal-brand-cta-secondary">${config.secondaryCta.text}</button>`)
            : '';

        const supportHtml = config.support
            ? ($('#tpl-modal-support').html() ?? '')
            : '';

        const accentStyle = config.accentColor ? ` style="--modal-brand-accent: ${config.accentColor}"` : '';
        const alertBadgeHtml = config.alertBadge ? '<span class="modal-brand-alert-badge">!</span>' : '';

        // Swap por extensión — .mp4 se muestra como <video> autoplay/loop en vez de <img>,
        // mismo config.icon para ambos casos. No hay ningún ícono en video en uso hoy (el único,
        // mrkey_cargando1.gif, es un gif normal), pero se deja el soporte sin costo por si vuelve
        // a usarse — si un día hay varios, formalizar con un config.video aparte.
        const iconMediaHtml = config.icon?.endsWith('.mp4')
            ? `<video src="${config.icon}" autoplay muted loop playsinline></video>`
            : `<img src="${config.icon}" alt="">`;
        const illustrationHtml = config.icon ? `
            <div class="modal-brand-illustration${config.loading ? ' modal-brand-illustration--loading' : ''}"${accentStyle}>
                <div class="modal-brand-illustration-inner">
                    ${iconMediaHtml}
                </div>
                ${alertBadgeHtml}
            </div>
        ` : '';

        modalDialog.html(`
            ${closeBtn}
            <div class="title-modal text-center">
                <span class="modal-brand-eyebrow">${x_textos['766-0'] ?? (alk_lang === 'en' ? 'Message from' : 'Mensaje de')} <strong>alkilautos.com</strong></span>
                ${illustrationHtml}
            </div>
            <div class="modal-brand-body">
                ${config.title ? `<p class="modal-brand-title">${config.title}</p>` : ''}
                <p class="modal-brand-desc">${config.body}</p>
                ${highlightHtml}
                ${ctaHtml}
                ${secondaryCtaHtml}
            </div>
            ${supportHtml}
        `);

        // Sin onClick ni href el botón no tendría ninguna acción — por defecto, cierra el modal.
        if (config.cta && !config.cta.href) {
            $('#modal-brand-cta').on('click', config.cta.onClick ?? (() => modal.modal('hide')));
        }
        if (config.secondaryCta && !config.secondaryCta.href) {
            $('#modal-brand-cta-secondary').on('click', config.secondaryCta.onClick ?? (() => modal.modal('hide')));
        }

        if (config.autoCloseMs) {
            setTimeout(() => { modal.modal('hide'); }, config.autoCloseMs);
        }

        modal.one('hidden.bs.modal', () => { modal.removeClass('modal-brand modal-brand-no-icon'); });
    }

    temporizadorPagV2(callback: any, callbackTime: any = false) {
        let $timeVar: any = $('[data-time]');
        let time: any = $timeVar.attr('data-time');
        let expr_time: any = (time ? parseInt(time) : 1200) * 1000;
        let timeEnd: any = new Date(Date.now() + expr_time);


        let genera_timer = setInterval(function () {
            let ahora: any = new Date();
            let mil_sec: any = timeEnd - ahora;
            if (mil_sec <= 0) {
                clearInterval(genera_timer);
                callback();
            } else {
                if (callbackTime) callbackTime(mil_sec);
            }
        }, 1000);

        return genera_timer;
    }

    sendIALQ(dataForm: any, tiempo: any) {
        if (tiempo === 0) {
            $.ajax({ url: '/action/ialq/', type: 'POST', data: dataForm });
            return false
        }
        else {
            return setTimeout(function () {
                $.ajax({ url: '/action/ialq/', type: 'POST', data: dataForm });
            }, tiempo);
        }
    }

    printButtons(btn: any) {
        let print = '';
        for (let i in btn) {
            let url = '';

            switch (alk_lang) {
                case 'es':
                    url = btn[i].intLink;
                    break;
                default:
                    url = '/' + alk_lang + btn[i].intLink;
                    break;
            }

            print = print + '<a class="btn btn-success uppercase m-3" href="' + url + '">' + this.findText(btn[i].title) + '</a> &nbsp'
        }
        return print
    }

    /**
     * Expira las variantes legacy de la cookie con scope de dominio
     * (.host y .dominio-padre): si existen, le hacen sombra a la cookie
     * host-only en el header Cookie (la más vieja va primero).
     */
    private purgeDomainScopedCookie(name: string) {
        const host = location.hostname;
        document.cookie = `${name}=;path=/;domain=${host};Max-Age=0`;
        const parent = host.split('.').slice(-2).join('.');
        if (parent !== host) document.cookie = `${name}=;path=/;domain=${parent};Max-Age=0`;
    }

    createCookie(name: string, value: string, days?: number, _domain?: string) {
        let expires = '';
        if (days != null) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = `expires=${date.toUTCString()};`;
        }
        this.purgeDomainScopedCookie(name);
        // Host-only (sin atributo domain): aísla cada subdominio (testtemporal vs prod)
        document.cookie = `${name}=${encodeURIComponent(value)};${expires}path=/;SameSite=Lax;Secure`;
    }

    createCookieSeconds(name: string, value: string, seconds?: number, _domain?: string) {
        let expires = '';
        if (seconds != null) {
            const date = new Date();
            date.setTime(date.getTime() + (seconds * 1000));
            expires = `expires=${date.toUTCString()};`;
        }
        this.purgeDomainScopedCookie(name);
        document.cookie = `${name}=${encodeURIComponent(value)};${expires}path=/;SameSite=Lax;Secure`;
    }

    readCookie(name: string): string | null {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let c of ca) {
            c = c.trim();
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length));
            }
        }
        return null;
    }

    deleteCookie(name: string, _domain?: string) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax;Secure`;
        this.purgeDomainScopedCookie(name);
    }

    jSONInfo(config: any, option: any, callBack?: any) {
        option['csrf_token'] = this.getCsrfToken();  // Agrega el token CSRF a los datos
        let cnfAjax: any = {
            url: config.dir
            , type: config.type
            , data: option
            , dataType: "json"
            , success: function (data: any) {
                if (typeof callBack == 'function') callBack(data);
            }
            , error: function (data: any, status: any, e: any) {
                console.error("jSONInfo - No se pudo cargar la pagina: ", data.responseText);
            }
        };
        let $files = config.Files;
        if ($files != undefined && $files.length != 0) {
            cnfAjax.fileElementId = $files;
            (jQuery as any).ajaxFileUpload(cnfAjax);
        }
        else {
            $.ajax(cnfAjax);
        }
    }

    afterSubmit(data: any, id_form: any, cerrar: any) {
        let status = data?.status;
        if (status && !status.error) {
            let e: any = $('#' + id_form)[0];
            if (e) e.reset()
        }
        if (status?.localstorage) {
            for (let key in status.localstorage) {
                const value = status.localstorage[key]?.toString() || '';
                this.setLocalStorage(key, value);
            }
        }
        this.printMessages(data, id_form, cerrar);
    }


    printMessages(data: any, id_form: any, cerrar: any) {
        const $form = $('#' + id_form),
            $ctm_msg = $form.find('.ctm_msg'),
            status = data?.status || { error: true };

        if (!$form.length || !$ctm_msg.length) {
            // Si no hay contenedor de mensajes en el formulario, usamos el modal general
            if (data?.mensaje) {
                this.sendMsjModal(this.findText(data.mensaje), status.error ? "Error" : "Mensaje", !status.error);
            }
            return;
        }

        if ($ctm_msg.is(':visible')) $ctm_msg.slideUp('fast')

        $ctm_msg.text(this.findText(data?.mensaje || 'Error inesperado'))
        $ctm_msg.removeClass('alert alert-danger alert-success')
            .addClass(status.error ? 'alert alert-danger' : 'alert alert-success')

        $ctm_msg.slideDown('fast');
        setTimeout(() => {
            $ctm_msg.slideUp('fast');

            if (status.close && typeof cerrar == 'function') {
                cerrar()
            }

            if (status.reload) {
                window.location.reload()
            }

            if (status.go) {
                window.location.href = status.go
            }

            if (status.go_to) {
                window.location.href = status.go_to
            }

        }, status.error ? 9000 : 2000)
    }

    validateUser($email: any) {
        /*
        $('#modal-validate').modal({ dismissible: false});
        $('#modal-validate').modal('open');
        $('#form-reg-usuario')[0].reset();
        $('#modal-registrate').modal('close');
    
        */

        $('#modal-validate').modal().modal('show');

        let self = this;

        $("#form-validate").attr('action', '/action/validate-user/');
        $('#object').val($email);

        $('#form-validate').off('submit');

        $('#form-validate').on('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let form_validate: any = $(this);
            let attr = form_validate.serializeObject();

            // Convertir el objeto en un objeto clave-valor
            var formObject: any = {};
            $.each(attr, function (index, field) {
                formObject[field.name] = field.value;
            });

            let config = { dir: form_validate.attr('action'), type: form_validate.attr('method') };

            self.jSONInfo(config, formObject, function (data: any) {
                self.afterSubmit(data, 'form-validate', function () {
                    self.closeMsjModal();
                    setTimeout(function () {
                        ///$('#modal-login').modal('open');
                        $("#btn-login-modal").click(function (event) {
                            event.preventDefault();
                            $("#form-login-modal").submit();
                        });
                    }, 1000);
                });
            });

            return false;

        });
    }

    getUserinfo() {
        if (window.localStorage) {
            if (window.localStorage.getItem('_user') == null) {
                return { status: false }
            }
            else {

                try {
                    let u = window.localStorage.getItem('_user');
                    let _user = u ? JSON.parse(u) : []
                    _user.status = true
                    return _user
                } catch (error) {

                }

            }
        }
        return { status: false }
    }

    setLocalStorage(key: string, val: string) {
        const s = this.encryptAES(val, "aksdjashdkjss");
        localStorage.setItem(key, s);
    }

    getLocalStorage(key: any) {
        const v = localStorage.getItem(key);
        if (v) {
            return this.decryptAES(v, "aksdjashdkjss");
        } else {
            return null;
        }
    }

    getLocalStorageNew(key: any) {
        return localStorage.getItem(key);
    }

    setLocalStorageNew(key: string, val: string) {
        try {
            localStorage.setItem(key, val);
        } catch (e) {
            console.error("ERROR al guardar en localStorage:", e);
        }
    }

    clearLocalStoragePrefix(prefix: string) {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(prefix)) {
                localStorage.removeItem(key);
            }
        }
    }

    getLocalPrefix(prefix: string) {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(prefix)) {
                return localStorage.getItem(key);
            }
        }
    }
    getLocalStoragePrefix(prefix: string, cod: string): void {
        Object.keys(localStorage)
            .filter(key => key.startsWith(prefix))
            .forEach(key => {
                const item = localStorage.getItem(key);
                if (item) {
                    try {
                        localStorage.removeItem(key);
                        const parsed = JSON.parse(item);
                        parsed.cardSelected = cod;
                        this.setLocalStorageNew(key, JSON.stringify(parsed));
                    } catch (error) { console.error(`Error processing key ${key}:`, error); }
                }
            });
    }

    removeLocalStorage(key: string) {
        localStorage.removeItem(key);
    }

    decryptAES(value: string, key: string) {
        return AES.decrypt(value, key).toString(Utf8);
    }

    encryptAES(value: string, key: string) {
        return AES.encrypt(value, key).toString();
    }

    getSha1(text: string): string {
        return SHA1(text).toString(Hex);
    }

    compressEncodedURI(data: string): string {
        return LZString.compressToEncodedURIComponent(data);
    }

    decompressEncodedURI(compressedData: string): string {
        return LZString.decompressFromEncodedURIComponent(compressedData);
    }

    getFormData(dataForm: any, $filesArray: any = []) {
        let formData = new FormData();
        for (let k in dataForm) {
            formData.append(dataForm[k].name, dataForm[k].value);
        }

        $filesArray.forEach(($file: any) => {
            formData.append($file.attr('name'), $file.get(0).files[0]);
        });

        formData.append('csrf_token', this.getCsrfToken());  // Agrega el token CSRF a los datos

        return formData
    }

    initAutoCiudad($input: JQuery<HTMLInputElement>,
        componentForm: { field: string, input: JQuery<HTMLInputElement>, type: 'long_name' | 'short_name' }[],
        zipCodeInput?: JQuery<HTMLInputElement>) {
        if ($input.length == 0) return;

        const loader = new Loader({
            apiKey: "AIzaSyBX3sk5jCiaS1NpTKb27Rx0k5Si06s2lR0",
            version: "weekly"
        });

        loader.importLibrary('places').then(() => {
            let placeholder = $input.attr('placeholder')
                , attr_autocomplete = $input.attr('autocomplete')
                , type = attr_autocomplete == 'shipping locality' ? ['(cities)'] : ['address']
                , autocomplete = new google.maps.places.Autocomplete($input[0], { types: type });

            $input.attr({ placeholder: placeholder, autocomplete: attr_autocomplete });
            autocomplete.addListener('place_changed', function () {
                let place = autocomplete.getPlace();

                try {
                    const postalCode = place?.address_components?.find((component: any) => component.types.includes('postal_code'))?.long_name;
                    zipCodeInput?.val(postalCode || '');
                } catch (error) { }

                if (componentForm == undefined || componentForm.length == 0) return;
                for (let k in componentForm) {
                    if (place.address_components == undefined) return false;
                    for (let y in place.address_components) {
                        if (place.address_components[y].types.includes(componentForm[k].field)) {
                            componentForm[k].input.val(place.address_components[y][componentForm[k].type] || '');
                            break;
                        }
                    }
                };
            });
        });
    }

    /*statusGoogle() {
        if (typeof google !== "undefined") {
            return true;
        }
        else {
            setTimeout(this.statusGoogle, 50);
        }
    }

    iniciarAutocompleteGoogle(id_input: any, calculos: any = {}) {
        let self = this;
        var $input = $('#' + id_input)
        if ($input.length == 0) return false;
        let autocomplete = new google.maps.places.Autocomplete($input[0], { types: ['address'] })
            , setDirection = function (direction: any, id_input: any, $input: any) {
                self.getGeodecoder(direction, function (status: any, lat: any, lng: any, placeName: any) {
                    $input.removeAttr('disabled')
                    if (status) {
                        $input.val(placeName);
                        self.getLatLng($input, id_input, lat, lng, calculos)
                    }
                    else {
                        $input.val('');
                        self.setErrorAutocomplete($input)
                    }
                    $input.attr('data-status', 'check')
                })
            }
        autocomplete.addListener('place_changed', function () {
            let place = autocomplete.getPlace()
                , lat = 0
                , lng = 0
            if (place.geometry != undefined) {
                lat = place.geometry.location.lat()
                lng = place.geometry.location.lng()
                if (calculos != undefined) self.getLatLng($input, id_input, lat, lng, calculos)
                $input.attr('data-status', 'check')
            }
            else {
                let direction: any = $('.pac-container:visible .pac-item').first().text();
                if (direction == "") direction = $input.val()
                $input.attr('disabled', 'disabled')
                setDirection(direction, id_input, $input)
            }
        })

        $input.keypress(function (e) {
            if (e.which != 13) {
                $input.removeAttr('data-status')
            }
        })
        $input.blur(function (e) {
            setTimeout(function () {
                let status = $input.attr('data-status') == 'check'
                    , cambio = !status && $input.val() != ''

                if (!status && !cambio) {
                    self.setErrorAutocomplete($input)
                }
                else if (cambio) {
                    setDirection($input.val(), id_input, $input)
                }
            }, 80)
        })
    }*/

    getGeodecoder(dir_to_geo: any, callback: any) {
        let geocoder = new google.maps.Geocoder()
        geocoder.geocode({ "address": dir_to_geo }, function (results: any, status: any) {
            if (status == google.maps.GeocoderStatus.OK) {
                var lat = results[0].geometry.location.lat(),
                    lng = results[0].geometry.location.lng(),
                    placeName = results[0].formatted_address;

                if (callback != undefined) {
                    callback(true, lat, lng, placeName)
                }

            }
            else {
                if (callback != undefined) {
                    callback(false)
                }
            }
        });
    }


    getLatLng($input: any, id_input: any, lat: any, lng: any, calculos: any) {
        let $error = $input.parents('.datos-domicilio').find('.error')

        if ($error.length) {
            $error.remove()
            $input.removeClass('invalid')
        }

        let recogida = id_input === 'dir-origen' ? 1 : 0,
            entrega = id_input === 'dir-recogida' ? 1 : 0,
            cod_search = $('#cod-search').val()

        if (recogida || entrega) {
            let opts = {
                cod: cod_search,
                recogida: recogida,
                entrega: entrega,
                latDomi: lat,
                lngDomi: lng,
                dirDomi: $input.val()
            }
            $input.attr({ 'data-lat': lat, 'data-lng': lng })
            this.jSONInfo({ dir: '/action/getDelivery/', type: 'POST' }, opts, function (data: any) {
                let $reserva = $('#reserva')
                    , ans = data.ans
                    , dataName = recogida ? 'cost_min_domi_i' : (entrega ? 'cost_min_domi_f' : '')
                    , costo = ans.costo

                if (ans.status) {
                    $reserva.attr('data-' + dataName, costo)
                    //calculos.showAllData()  
                } else {
                    $input.parent().append('<span class="error">' + ans.err + '</span>')
                    $input.addClass('invalid')
                }
            })
        }
    }

    setErrorAutocomplete($input: any) {
        let $error = $input.parents('.datos-domicilio').find('.error')
        if ($error.length) {
            $error.remove()
            $input.removeClass('invalid')
        }
        $input.parent().append('<span class="error">' + x_textos["570-0"] + '</span>')
        $input.addClass('invalid')
    }

    getClone(obj: any): any {

        let copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.getClone(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = Object.create(obj);
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.getClone(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    setInputValue(element: JQuery, value: any): void {
        if (element.is('input[type="checkbox"]')) {
            if (!Array.isArray(value)) return;
            $(`input[name="${element.attr('name')}"]`).each(function () {
                if (value.includes($(this).val())) {
                    $(this).prop('checked', true).trigger('change');
                }
            });
        } else if (element.is('input[type="radio"]')) {
            $(`input[name="${element.attr('name')}"][value="${value}"]`).prop('checked', true).trigger('change');
        } else if (!element.is('input[type="file"]')) {
            element.val(value).trigger('change');;
        }
    }

    getInputValue(element: JQuery): any {
        if (element.is('input[type="checkbox"]')) {
            let checkedValues: any = [];
            $(`input[name="${element.attr('name')}"]:checked`).each(function () {
                checkedValues.push($(this).val());
            });
            return checkedValues;
        }
        if (element.is('input[type="radio"]')) {
            return $(`input[name="${element.attr('name')}"]:checked`).val();
        }
        if (!element.is('input[type="file"]'))
            return element.val();
    }

    getDateActualToString(seconds_future: any = null) {
        // Obtiene la fecha y hora actual
        const now = new Date();

        // Agrega 120 segundos (convertidos a milisegundos) a la fecha actual
        const futureDate = new Date(now.getTime() + (seconds_future ? seconds_future : 0) * 1000);

        // Formatea la fecha y hora en un string en el formato deseado
        const formattedDateTime = `${futureDate.getFullYear()}-${(futureDate.getMonth() + 1).toString().padStart(2, '0')}-${futureDate.getDate().toString().padStart(2, '0')} ${futureDate.getHours().toString().padStart(2, '0')}:${futureDate.getMinutes().toString().padStart(2, '0')}:${futureDate.getSeconds().toString().padStart(2, '0')}`;

        return formattedDateTime;
    }

    getCsrfToken() {
        let token = $('meta[name="csrf-token"]').attr('content');
        return token ? token : '';
    }

    getDateFormat(stringDate: string): Date | undefined {
        if (!stringDate) return;

        const [dayStr, monthStr, yearStr] = stringDate?.split('/');

        if (!dayStr || !monthStr || !yearStr) return;

        const day = Number(dayStr);
        const month = Number(monthStr);
        const year = Number(yearStr);

        if (isNaN(day) || isNaN(month) || isNaN(year)) return;

        const date = new Date(year, month - 1, day, 0, 0, 0, 0);

        if (
            date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day
        ) return date;
    }

    sprint_f(format: string, ...args: string[]): string {
        return format.replace(/{(\d+)}/g, (match, index) => {
            return typeof args[index] !== 'undefined' ? args[index] : match;
        });
    }
}